import { Reason } from "./types";

/** Igual ao BE (`MIN_REASON_TEXT_LENGTH`): texto aparado com menos de 3 caracteres é inválido. */
export const TEXT_MIN = 3;
export const TEXT_MAX = 2000;
export const TEXT_ERROR = "Escreva o detalhe (mínimo 3 caracteres).";

export const needsText = (chosen: Reason[]) => chosen.some((r) => r.requiresText);
export const textError = (required: boolean, text: string) => (required && text.trim().length < TEXT_MIN ? TEXT_ERROR : null);
